var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ACCOUNT_EVENTS = {
    ACCOUNT_VIEW: 'view_account',
};
var CHANGES_POPUP_EVENTS = {
    CHANGES_POPUP_KEEP_EDITING: 'click-keep_editing_changes_popup',
    CHANGES_POPUP_DISCARD: 'click-discard_changes_popup',
    CHANGES_POPUP_ESC: 'click-esc_changes_popup',
};
var NAVIGATION_EVENTS = {
    NAVIGATION_FOOTER_CONTACT: 'click-contact_footer',
    NAVIGATION_FOOTER_FEEDBACK: 'click-feedback_footer',
    NAVIGATION_FOOTER_FEEDING_GUIDE: 'click-feeding_guide_footer',
    NAVIGATION_FOOTER_HELP: 'click-help_footer',
    NAVIGATION_FOOTER_RAF: 'click-RAF_footer',
    NAVIGATION_FOOTER_RETAIL: 'click-retail_footer',
    NAVIGATION_HEADER_ACCOUNT: 'click-account_navigation',
    NAVIGATION_HEADER_CONTACT: 'click-contact_navigation',
    NAVIGATION_HEADER_EXTRAS: 'click-extras_navigation',
    NAVIGATION_HEADER_HELP: 'click-help_navigation',
    NAVIGATION_HEADER_LOGO: 'click-logo_navigation',
    NAVIGATION_HEADER_LOGOUT: 'click-logout_navigation',
    NAVIGATION_HEADER_PETS: 'click-pets_navigation',
    NAVIGATION_HEADER_PLAN: 'click-plan_navigation',
    NAVIGATION_HEADER_RAF: 'click-RAF_navigation',
};
var ONBOARDING_EVENTS = {
    ONBOARDING_VIEW_WELCOME: 'view-welcome_onboarding',
    ONBOARDING_CLICK_CONTINUE_WELCOME: 'click-continue_welcome_onboarding',
    ONBOARDING_VIEW_SET_PASSWORD: 'view-set_password_onboarding',
    ONBOARDING_CLICK_SET_PASSWORD: 'click-set_password_onboarding',
    ONBOARDING_VIEW_ADD_PHOTO: 'view-add-photo_onboarding',
    ONBOARDING_CLICK_SKIP_PHOTO: 'click-skip_photo_onboarding',
    ONBOARDING_CLICK_SAVE_PHOTO: 'click-save_photo_onboarding',
    ONBOARDING_CLICK_LATER_PHOTO: 'click-later_photo_onboarding',
    ONBOARDING_VIEW_PREVIOUS_FOOD: 'view-complete_profile_onboarding',
    ONBOARDING_CLICK_SKIP_PROFILE: 'click-skip_profile_onboarding',
    ONBOARDING_CLICK_SAVE_PROFILE: 'click-save_profile_onboarding',
    ONBOARDING_CLICK_LATER_PROFILE: 'click-later_profile_onboarding',
    ONBOARDING_VIEW_HDYHAU: 'view-hdyhau-onboarding',
    ONBOARDING_CLICK_SKIP_HDYHAU: 'click-skip_hdyhau_onboarding',
    ONBOARDING_CLICK_CONTINUE_HDYHAU: 'click-continue_hdyhau_onboarding',
    ONBOARDING_CLICK_NO_ANSWER_HDYHAU: 'click-no_answer_hdyhau_onboarding',
    ONBOARDING_VIEW_ALL_SET: 'view-all_set_onboarding',
    ONBOARDING_CLICK_FINISH_ALL_SET: 'click-finish_all_set_onboarding',
    ONBOARDING_CLICK_CONTACT_ALL_SET: 'click-contact_all_set_onboarding',
};
var FEEDBACK_PAGE_EVENTS = {
    FEEDBACK_PAGE_VIEW: 'view-feedback',
    FEEDBACK_PAGE_CLICK_HELP: 'click-help_feedback',
    FEEDBACK_PAGE_CLICK_CONTACT: 'click-contact_feedback',
    FEEDBACK_PAGE_CLICK_SUBMIT_FEEDBACK: 'click-submit_feedback_feedback',
    FEEDBACK_PAGE_VIEW_THANK_YOU: 'view-thank_you_feedback',
    FEEDBACK_PAGE_CLICK_PLAN_THANK_YOU: 'click-plan_thank_you_feedback',
    FEEDBACK_PAGE_CLICK_HELP_THANK_YOU: 'click-help_thank_you_feedback',
    FEEDBACK_PAGE_CLICK_CONTACT_THANK_YOU: 'click-contact_thank_you_feedback',
};
var MANAGE_DELIVERY_EVENTS = {
    DELIVERY_DAY_VIEW: 'view-delivery_day',
    DELIVERY_DAY_CLICK_BACK_TO_PLAN: 'click-back_to_plan_delivery_day',
    DELIVERY_DAY_CLICK_TOOLTIP: 'click-tooltip_delivery_day',
    DELIVERY_DAY_CLICK_SAVE_CHANGES: 'click-save_changes_delivery_day',
    DELIVERY_DAY_CLICK_GO_BACK: 'click-go_back_delivery_day',
    DELIVERY_DAY_CLICK_EDIT_ADDRESS: 'click-edit_address_delivery_day',
    DELIVERY_FREQUENCY_VIEW: 'view-delivery_frequency',
    DELIVERY_FREQUENCY_CLICK_BACK_TO_PLAN: 'click-back_to_plan_delivery_frequency',
    DELIVERY_FREQUENCY_CLICK_SAVE_CHANGES: 'click-save_changes_delivery_frequency',
    DELIVERY_FREQUENCY_CLICK_GO_BACK: 'click-go_back_delivery_frequency',
    DELIVERY_FREQUENCY_CLICK_UPDATE_DELIVERY_DAY: 'click-delivery_day_delivery_frequency',
};
var MANAGE_DELIVERY_DRAWER_PLAN_HOME_EVENTS = {
    MANAGE_DELIVERY_DRAWER_PLAN_VIEW: 'view-manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CLOSE: 'click-close_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_SKIP_THIS_BOX: 'click-skip_this_box_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_VIEW_CONFIRM_SKIP_THIS_BOX: 'view-confirm_skip_this_box_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CONFIRM_SKIP_THIS_BOX: 'click-confirm_skip_this_box_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CLOSE_CONFIRM_SKIP_THIS_BOX: 'click-close_confirm_skip_this_box_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_BACK_CONFIRM_SKIP_THIS_BOX: 'click-back_confirm_skip_this_box_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_RESCHEDULE: 'click-reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_VIEW_CALENDAR_RESCHEDULE: 'view-calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_BACK_CALENDAR_RESCHEDULE: 'click-back_calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_DATE_CALENDAR_RESCHEDULE: 'click-date_calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_RESCHEDULE_DELIVERY_CALENDAR_RESCHEDULE: 'click-reschedule_delivery_calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CLOSE_CALENDAR_RESCHEDULE: 'click-close_calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CHANGE_DELIVERY_DAY_CALENDAR_RESCHEDULE: 'click-change_delivery_day_calendar_reschedule_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_VIEW_CHANGE_DELIVERY_DAY: 'view-change_delivery_day_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_BACK_CHANGE_DELIVERY_DAY: 'click-back_change_delivery_day_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_CLOSE_CHANGE_DELIVERY_DAY: 'click-close_change_delivery_day_manage_delivery_drawer_plan',
    MANAGE_DELIVERY_DRAWER_PLAN_CLICK_SAVE_CHANGES_CHANGE_DELIVERY_DAY: 'click-save_changes_change_delivery_day_manage_delivery_drawer_plan',
};
var PLAN_HOME_EVENTS = {
    PLAN_HOME_VIEW: 'view-plan',
    PLAN_HOME_VIEW_WELCOME_CARD: 'view-welcome_card',
    PLAN_HOME_CLICK_DISMISS_WELCOME_CARD: 'click-dismiss_welcome_card',
    PLAN_HOME_VIEW_ONBOARDING_GUIDE_CARD: 'view-onboarding_guide_card',
    PLAN_HOME_CLICK_DISMISS_ONBOARDING_GUIDE_CARD: 'click-dismiss_onboarding_guide_card',
    PLAN_HOME_CLICK_VIEW_ONBOARDING_ONBOARDING_GUIDE_CARD: 'click-view_onboarding_onboarding_guide_card',
    PLAN_HOME_VIEW_MIXED_RECIPES_PROMO_CARD: 'view-mixed_recipes_promo_card',
    PLAN_HOME_CLICK_DISMISS_MIXED_RECIPES_PROMO_CARD: 'click-dismiss_mixed_recipes_promo_card',
    PLAN_HOME_CLICK_TRY_MORE_RECIPES_MIXED_RECIPES_PROMO_CARD: 'click-try_more_recipes_mixed_recipes_promo_card',
    PLAN_HOME_VIEW_SWITCH_TO_FLEX_PROMO_CARD: 'view-switch_to_flex_promo_card',
    PLAN_HOME_CLICK_DISMISS_SWITCH_TO_FLEX_PROMO_CARD: 'click-dismiss_switch_to_flex_promo_card',
    PLAN_HOME_CLICK_SEE_OPTIONS_SWITCH_TO_FLEX_PROMO_CARD: 'click-see_options_switch_to_flex_promo_card',
    PLAN_HOME_CLICK_MANAGE_DELIVERY_NEXT_BOX: 'click-manage_delivery_next_box_plan',
    PLAN_HOME_CLICK_TRACK_PACKAGE_NEXT_BOX: 'click-track_package_next_box_plan',
    PLAN_HOME_CLICK_OPEN_DETAILS_NEXT_BOX: 'click-open_details_next_box_plan',
    PLAN_HOME_CLICK_CLOSE_DETAILS_NEXT_BOX: 'click-close_details_next_box_plan',
    PLAN_HOME_CLICK_EDIT_PET_MEALS_NEXT_BOX: 'click-edit_pet_meals_next_box_plan',
    PLAN_HOME_CLICK_EDIT_EXTRAS_NEXT_BOX: 'click-edit_extras_next_box_plan',
    PLAN_HOME_CLICK_VIEW_ORDER_DETAILS_NEXT_BOX: 'click-view_order_details_next_box_plan',
    PLAN_HOME_CLICK_MANAGE_DELIVERY_COMING_UP: 'click-manage_delivery_coming_up_plan',
    PLAN_HOME_CLICK_OPEN_DETAILS_COMING_UP: 'click-open_details_coming_up_plan',
    PLAN_HOME_CLICK_CLOSE_DETAILS_COMING_UP: 'click-close_details_coming_up_plan',
    PLAN_HOME_CLICK_EDIT_PET_MEALS_COMING_UP: 'click-edit_pet_meals_coming_up_plan',
    PLAN_HOME_CLICK_EDIT_EXTRAS_COMING_UP: 'click-edit_extras_coming_up_plan',
    PLAN_HOME_CLICK_SHOP_HEALTHY_EXTRAS_AD: 'click-shop_healthy_extras_ad_plan',
    PLAN_HOME_CLICK_MEET_MEALS_AD: 'click-meet_our_meals_ad_plan ',
    PLAN_HOME_CLICK_MEET_TREATS_AD: 'click-meet_our_treats_ad_plan',
    PLAN_HOME_CLICK_EDIT_PROFILE: 'click-edit_profile_plan',
    PLAN_HOME_CLICK_EDIT_MEAL_PLAN: 'click-edit_meal_plan_plan',
    PLAN_HOME_CLICK_VIEW_FEEDING_GUIDE: 'click-view_feeding_guide_plan',
    PLAN_HOME_CLICK_EDIT_DELIVERY_ADDRESS: 'click-edit_delivery_address_plan',
    PLAN_HOME_CLICK_EDIT_DELIVERY_DAY: 'click-edit_delivery_day_plan',
    PLAN_HOME_CLICK_EDIT_DELIVERY_FREQUENCY: 'click-edit_delivery_frequency_plan',
    PLAN_HOME_CLICK_PICK_PLAN: 'click-pick_plan_plan',
    PLAN_HOME_CLICK_OPEN_DETAILS_LAST_BOX: 'click-open_details_last_box_plan',
    PLAN_HOME_CLICK_CLOSE_DETAILS_LAST_BOX: 'click-close_details_last_box_plan',
    PLAN_HOME_CLICK_VIEW_ORDER_DETAILS_LAST_BOX: 'click-view_order_details_last_box_plan',
    PLAN_HOME_CLICK_START_MEAL_PLAN: 'click-start_meal_plan_plan',
    PLAN_HOME_CLICK_SHOP_RETAIL: 'click-shop_retail_plan',
    // OTTO
    PLAN_HOME_CLICK_TRACK_PACKAGE: 'click-track_package_plan',
    PLAN_HOME_CLICK_PRINT_INVOICE: 'click-print_invoice_plan',
    PLAN_HOME_CLICK_GET_HELP: 'click-get_help_plan',
    PLAN_HOME_CLICK_CREATE_NEW_PLAN: 'click-create_new_plan_plan',
    PLAN_HOME_CLICK_CHANGE_PASSWORD: 'click-change_password_plan',
};
var CONTACT_PAGE_EVENTS = {
    CONTACT_PAGE_VIEW: 'view-contact_info',
    CONTACT_PAGE_CLICK_BACK_TO_ACCOUNT: 'click-back_to_account_contact_info',
    CONTACT_PAGE_CLICK_SAVE: 'click-save_changes_contact_info',
    CONTACT_PAGE_CLICK_GO_BACK: 'click-go_back_contact_info',
};
var PASSWORD_PAGE_EVENTS = {
    PASSWORD_PAGE_VIEW: 'view-password',
    PASSWORD_PAGE_CLICK_BACK_TO_ACCOUNT: 'click-back_to_account_password',
    PASSWORD_PAGE_CLICK_SAVE: 'click-change_password_password',
    PASSWORD_PAGE_CLICK_GO_BACK: 'click-go_back_password',
};
var PAYMENT_PAGE_EVENTS = {
    PAYMENT_PAGE_VIEW: 'view-update_payment',
    PAYMENT_PAGE_CLICK_BACK_TO_ACCOUNT: 'click-back_to_account_update_payment',
    PAYMENT_PAGE_CLICK_SAVE: 'click-update_update_payment',
    PAYMENT_PAGE_CLICK_CVC_HINT: 'click-cvc_hint_update_payment',
    PAYMENT_PAGE_CLICK_GO_BACK: 'click-go_back_update_payment',
};
var PETS_HOME_EVENTS = {
    PETS_VIEW: 'view_pets',
    PETS_CLICK_UPDATE_PROFILE: 'click-update_profile_pets',
    PETS_CLICK_EDIT_MEAL_PLAN: 'click-edit_meal_plan_pets',
    PETS_CLICK_VIEW_FEEDING_GUIDE: 'click-view_feeding_guide_pets',
    PETS_CLICK_START_MEAL_PLAN: 'click-start_meal_plan_pets',
    PETS_CLICK_ADD_NEW_DOG: 'click-add_new_dog_pets',
    PETS_CLICK_BUY_ADDITIONAL_MEAL_PACKS: 'click-buy_additional_meal_packs_pets',
    PETS_CLICK_SEND_VET_INFO: 'click-send_vet_info_pets',
};
var PET_PROFILE_EVENTS = {
    PET_PROFILE_VIEW: 'view-pet_profile',
    PET_PROFILE_CLICK_BACK_TO_PETS: 'click-back_to_pets_pet_profile',
    PET_PROFILE_CLICK_EDIT_PHOTO: 'click-edit_photo_pet_profile',
    PET_PROFILE_CLICK_MALE_GENDER: 'click-male_gender_pet_profile',
    PET_PROFILE_CLICK_FEMALE_GENDER: 'click-female_gender_pet_profile',
    PET_PROFILE_CLICK_AVERAGE_ACTIVITY: 'click-average_activity_pet_profile',
    PET_PROFILE_CLICK_ACTIVE_ACTIVITY: 'click-active_activity_pet_profile',
    PET_PROFILE_CLICK_ATHLETE_ACTIVITY: 'click-athlete_activity_pet_profile',
    PET_PROFILE_CLICK_SELECT_PICKY_EATER: 'click-select_picky_eater_pet_profile',
    PET_PROFILE_CLICK_DESELECT_PICKY_EATER: 'click-deselect_picky_eater_pet_profile',
    PET_PROFILE_CLICK_SELECT_ALLERGIES: 'click-select_allergies_pet_profile',
    PET_PROFILE_CLICK_DESELECT_ALLERGIES: 'click-deselect_allergies_pet_profile',
    PET_PROFILE_CLICK_SELECT_COAT_ISSUES: 'click-select_coat_issues_pet_profile',
    PET_PROFILE_CLICK_DESELECT_COAT_ISSUES: 'click-deselect_coat_issues_pet_profile',
    PET_PROFILE_CLICK_SELECT_NO_ISSUES: 'click-select_no_issues_pet_profile',
    PET_PROFILE_CLICK_DESELECT_NO_ISSUES: 'click-deselect_no_issues_pet_profile',
    PET_PROFILE_CLICK_SAVE_CHANGES: 'click-save_changes_pet_profile',
    PET_PROFILE_CLICK_GO_BACK: 'click-go_back_pet_profile',
    PET_PROFILE_CLICK_UPDATE_PLAN: 'click-update_plan_pet_profile',
};
var ACCOUNT_SETTINGS_EVENTS = {
    ACCOUNT_SETTINGS_VIEW: 'view-account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_CONTACT: 'click-edit_contact_account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_PASSWORD: 'click-edit_password_account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_PAYMENT: 'click-edit_payment_account_settings',
    ACCOUNT_SETTINGS_CLICK_VIEW_ORDER_HISTORY: 'click-view_order_history_account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_ADDRESS: 'click-edit_address_account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_DELIVERY_DAY: 'click-edit_delivery_day_account_settings',
    ACCOUNT_SETTINGS_CLICK_EDIT_DELIVERY_FREQUENCY: 'click-edit_delivery_frequency_account_settings',
    ACCOUNT_SETTINGS_CLICK_CANCEL_SUBSCRIPTION: 'click-cancel_subscription_account_settings',
    ACCOUNT_SETTINGS_CLICK_CONTACT_US_CANCEL_SUBSCRIPTION: 'click-contact_us_cancel_subscription_account_settings',
    ACCOUNT_SETTINGS_CLICK_START_PLAN: 'click-start_plan_account_settings',
    ACCOUNT_SETTINGS_CLICK_REACTIVATE_PLAN: 'click-reactivate_plan_account_settings',
};
var INTERACTION_EVENT = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, ACCOUNT_EVENTS), ACCOUNT_SETTINGS_EVENTS), CHANGES_POPUP_EVENTS), CONTACT_PAGE_EVENTS), FEEDBACK_PAGE_EVENTS), MANAGE_DELIVERY_EVENTS), MANAGE_DELIVERY_DRAWER_PLAN_HOME_EVENTS), NAVIGATION_EVENTS), ONBOARDING_EVENTS), PASSWORD_PAGE_EVENTS), PAYMENT_PAGE_EVENTS), PETS_HOME_EVENTS), PLAN_HOME_EVENTS), PET_PROFILE_EVENTS);
export { ACCOUNT_EVENTS, ACCOUNT_SETTINGS_EVENTS, CHANGES_POPUP_EVENTS, CONTACT_PAGE_EVENTS, FEEDBACK_PAGE_EVENTS, MANAGE_DELIVERY_EVENTS, MANAGE_DELIVERY_DRAWER_PLAN_HOME_EVENTS, NAVIGATION_EVENTS, ONBOARDING_EVENTS, PASSWORD_PAGE_EVENTS, PAYMENT_PAGE_EVENTS, PETS_HOME_EVENTS, PLAN_HOME_EVENTS, INTERACTION_EVENT, PET_PROFILE_EVENTS, };
